import { themes } from 'kb-shared';
import styled from 'styled-components';

export const AdditionalInfoPanel = styled.div`
  font-size: 14px;
  color: ${themes.colors.neutral.primaryNavy};
  padding: 20px 10px 10px 10px;

  strong {
    font-size: 16px;
  }

  a {
    text-decoration: underline;
  }
`;
